import { Transition } from "../../../core/flows/Transition";
import { BookItAgainContext } from "../../BookItAgain/Context/BookItAgainContext";
import { FavouriteDepartureContext } from "../../FavouriteDeparture/Context/FavouriteDepartureContext";
import { MainBookingContext } from "../../MainBookingFlow/Context/MainBookingContext";
import { TopBarContext } from "../../TopBar/Context/TopBarContext";
import { HomePageContext } from "../Context/HomePageContext";

export class HomePageTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {
        const context = this.getCtx<HomePageContext>("HomePageContext", this.entryStep);

        const mainBookingContext = new MainBookingContext()
        mainBookingContext.userName = `${context?.firstName || ""} ${context?.lastName}`

        const topBarContext = new TopBarContext()
        topBarContext.userName = `${context?.firstName || ""} ${context?.lastName}`

        const bookItAgainContext = new BookItAgainContext()

        const favouriteDepartureContext = new FavouriteDepartureContext()

        this.setCtx<MainBookingContext>("MainBookingContext", mainBookingContext, this.entryStep)
        this.setCtx<TopBarContext>("TopBarContext", topBarContext, this.entryStep)
        this.setCtx<BookItAgainContext>("bookItAgainContext", bookItAgainContext, this.entryStep)

        this.setCtx<FavouriteDepartureContext>("favouriteDepartureContext", favouriteDepartureContext, this.entryStep)

        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${this.getCtx("choice")}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }

}